import styled, {css} from 'styled-components'

export const StyledNewEmail = styled.p(
    ({theme: {palette, typography}}) => css`
        ${typography.textMd};
        color: ${palette.neutral['400']};
    `
)

export const StyledCurrentEmailLabel = styled.p(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral['600']};
        font-weight: 500;
    `
)

export const StyledCurrentEmail = styled.p(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral['950']};
        font-weight: 500;
    `
)
